"use strict";
exports.__esModule = true;
exports.reactivePluginKey = void 0;
var prosemirror_state_1 = require("prosemirror-state");
exports.reactivePluginKey = new prosemirror_state_1.PluginKey("reactive");
